import { InfoLineKeys, InfoLineProperties, InfoLineType } from './models'
import { NumericFormat } from 'react-number-format'
import { getText } from '../../../internal/Text'
import moment from 'moment'
import styles from './priceinfo.module.scss'
import { getLocale } from '../PriceInfo'

const CommonNumberFormat = props => (
  <NumericFormat
    displayType="text"
    thousandSeparator=" "
    decimalSeparator=","
    decimalScale="2"
    fixedDecimalScale
    {...props}
  />
)

export const renderInfoHeader = header => (
  <div className={styles.infoHeader}>{header}</div>
)

export const renderInfoLine = (key, value, showReservation = true) => {
  return value != null ? (
    <div className={styles.infoLine}>
      <span>{getText(InfoLineProperties[key].label)}: </span>
      {getInfoLineBody(key, value)}
      {showReservation &&
        InfoLineProperties[key].reservations &&
        ` ${[...Array(InfoLineProperties[key].reservations).keys()]
          .map(() => '*')
          .join('')}`}
    </div>
  ) : null
}

export const haveFlexProducts = options => {
  return (
    options.filter(option => option.type.toUpperCase() === 'FLEX').length > 0
  )
}
export const renderOption = (
  priceInfo,
  {
    name,
    durationInMonths,
    interest,
    monthlyAdminFee,
    accountFee,
    normalMonthlyRepaymentAmount,
    effectiveInterest,
    totalLoanCost,
    arrangementFee,
    creditCost,
    type,
  },
  idx,
) => {
  const locale = getLocale()

  const shouldHideReservations = !(
    priceInfo.name.toUpperCase() === 'KOMPLETT FLEX' && locale.country === 'NO'
  )

  if (
    locale.country === 'NO' &&
    name.includes('RENTEFRI') &&
    interest === 0 &&
    arrangementFee !== 0
  ) {
    const currentName = name.split(' ')[0]
    name = `${currentName} MDR. UTEN NOMINELL RENTE`
  }
  return (
    <div key={idx} className={styles.item}>
      {renderInfoHeader(name)}
      {renderInfoLine(InfoLineKeys.DURATION_IN_MONTHS, durationInMonths)}
      {renderInfoLine(
        InfoLineKeys.NORMAL_MONTHLY_REPAYMENT_AMOUNT,
        normalMonthlyRepaymentAmount,
      )}
      {renderInfoLine(InfoLineKeys.CREDIT_AMOUNT, priceInfo.amount)}
      {renderInfoLine(InfoLineKeys.INTEREST, interest)}
      {locale.country === 'FI'
        ? null
        : renderInfoLine(
            InfoLineKeys.ARRANGEMENT_FEE,
            arrangementFee,
            shouldHideReservations,
          )}
      {monthlyAdminFee != null &&
        monthlyAdminFee !== 0 &&
        renderInfoLine(InfoLineKeys.MONTHLY_ADMIN_FEE, monthlyAdminFee)}
      {accountFee != null &&
        accountFee !== 0 &&
        renderInfoLine(InfoLineKeys.ACCOUNT_FEE, accountFee)}
      {renderInfoLine(InfoLineKeys.EFFECTIVE_INTEREST, effectiveInterest)}
      {renderInfoLine(InfoLineKeys.CREDIT_COST, creditCost)}
      {renderInfoLine(InfoLineKeys.TOTAL_LOAN_COST, totalLoanCost)}
    </div>
  )
}

export const renderFlexibleInvoiceOption = ({
  creditAmount,
  invoiceFee,
  dueDate,
  duration,
  totalCost,
}) => {
  const days = moment.duration(duration).asDays()
  return (
    <div className={styles.item}>
      {renderInfoLine(InfoLineKeys.CREDIT_AMOUNT, creditAmount)}
      {renderInfoLine(InfoLineKeys.INVOICE_FEE, invoiceFee)}
      {renderInfoLine(InfoLineKeys.DUE_DATE, dueDate)}
      {renderInfoLine(InfoLineKeys.PAYMENT_PERIOD, days)}
      {renderInfoLine(InfoLineKeys.TOTAL_COST, totalCost)}
    </div>
  )
}

export const renderFooter = () => (
  <div className={styles.footerContainer}>
    <div className={styles.wave} />
    <div className={styles.info}>
      <div className={styles.textBoxWrapper}>
        <div className={styles.logotype} />
        <div className={styles.textBox}>
          <div>{copyrightText()}</div>
          <div>{getText('footer.2')}</div>
          <div>{getText('footer.3')}</div>
        </div>
      </div>
    </div>
  </div>
)

const getInfoLineBody = (key, value) => {
  const type = InfoLineProperties[key].type
  if (type === InfoLineType.CURRENCY) {
    return (
      <CommonNumberFormat
        value={value}
        renderText={val => getText('default.currency', val)}
      />
    )
  } else if (type === InfoLineType.PERCENTAGE) {
    return <CommonNumberFormat value={value} renderText={val => `${val} %`} />
  } else if (type === InfoLineType.DATE) {
    return moment(value).format('LL')
  } else if (type === InfoLineType.DAY) {
    return `${value} ${
      value === 1
        ? getText('priceInfo.general.day')
        : getText('priceInfo.general.days')
    }`
  } else if (type === InfoLineType.MONTH) {
    return `${value} ${
      value === 1
        ? getText('priceInfo.general.month')
        : getText('priceInfo.general.months')
    }`
  }
}

const copyrightText = () => {
  return `© ${new Date().getFullYear()} ${getText('footer.1')}`
}

export const shouldShowSecondReservationText = priceInfo => {
  const country = getLocale().country
  const isKomplettFlex = priceInfo.name.toUpperCase() === 'KOMPLETT FLEX'
  return country !== 'FI' && !(country === 'NO' && isKomplettFlex)
}

export const breakLines = text =>
  text.split('<br>').map((str, i) =>
    i === 0 ? (
      <>{str}</>
    ) : (
      <>
        <br />
        <br />
        {str}
      </>
    ),
  )
